// Geosort, contrato v1.1.
// Shopify solo filtra la coleccion de la URL, asi que la vista filtrada se pide
// a la coleccion de Geosort del visitante (data-geosort-view, la pinta
// sections/main-collection-product-grid.liquid) para que salga en su orden. La
// barra de direcciones y todos los enlaces siguen en la coleccion original,
// salvo el "cargar mas" (data-geosort-next), que tiene que seguir pidiendo la
// coleccion de Geosort. Con un orden elegido por el cliente o cualquier fallo,
// se pide la vista de siempre.
function geosortFacetRoute(nativeUrl) {
  try {
    const grid = document.getElementById('product-grid');
    const shadow = grid && grid.dataset.geosortView;
    const parentPath = window.location.pathname.replace(/\/$/, '');
    const match = parentPath.match(/\/collections\/([^/]+)$/);
    if (!shadow || !match || match[1] === shadow) return null;
    const url = new URL(nativeUrl, window.location.origin);
    if (url.searchParams.has('q')) return null;
    // Con sort_by repetido manda el ultimo, como en Shopify: el cajon movil
    // anade created-descending detras del de por defecto.
    const sorts = url.searchParams.getAll('sort_by');
    const sortBy = sorts.length ? sorts[sorts.length - 1] : '';
    if (sortBy && sortBy !== (grid.dataset.geosortDefaultSort || '')) return null;
    url.searchParams.delete('sort_by');
    url.pathname = parentPath.slice(0, -match[1].length) + shadow;
    return { url: url.pathname + url.search, shadow, parentHandle: match[1] };
  } catch (e) {
    return null;
  }
}

function geosortToParent(html, route) {
  try {
    if (!html.includes(`data-geosort-view="${route.shadow}"`)) return null;
    const from = `/collections/${route.shadow}`;
    const pattern = new RegExp(`${from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?=[/?#&]|$)`, 'g');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('*').forEach((element) => {
      if (element.hasAttribute('data-geosort-next')) return;
      Array.from(element.attributes).forEach((attribute) => {
        if (attribute.value.includes(from)) {
          element.setAttribute(attribute.name, attribute.value.replace(pattern, `/collections/${route.parentHandle}`));
        }
      });
    });
    return doc.documentElement.outerHTML;
  } catch (e) {
    return null;
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const nativeUrl = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const geosortRoute = geosortFacetRoute(nativeUrl);
      const url = geosortRoute ? geosortRoute.url : nativeUrl;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event, geosortRoute, nativeUrl);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, geosortRoute, nativeUrl) {
    fetch(url)
      .then((response) => (response.ok ? response.text() : ''))
      .then((responseText) => {
        if (!geosortRoute) return responseText;
        const html = geosortToParent(responseText, geosortRoute);
        return html || fetch(nativeUrl).then((response) => response.text());
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        infiniteScrollCollection();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    infiniteScrollCollection();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    FacetFiltersForm.uploadGrid();
    facetsPriceRange();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      if (this.createSearchParams(event.target.closest('form')).includes("sort_by=manual")) {
        const searchParams = this.createSearchParams(event.target.closest('form')) + '&sort_by=created-descending';
        this.onSubmitForm(searchParams, event);
      } else {
        const searchParams = this.createSearchParams(event.target.closest('form'));
        this.onSubmitForm(searchParams, event);
      }
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  static uploadGrid() {
    const gridProducts = document.getElementById('product-grid');
    const gridIcons = document.querySelectorAll('.facet-grid-icon');
    const userChoice = localStorage.getItem('gridChoice');

    if (userChoice === 'alternate-grid') {
      gridIcons[0].classList.toggle('hidden');
      gridIcons[1].classList.toggle('hidden');
      gridProducts.classList.toggle('grid--4-col-desktop');
      gridProducts.classList.toggle('grid--2-col-desktop');
      gridProducts.classList.toggle('grid--2-col-tablet-down');
      gridProducts.classList.toggle('grid--1-col-tablet-down');
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    // const inputs = this.querySelectorAll('input');
    // const minInput = inputs[0];
    // const maxInput = inputs[1];
    // if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    // if (minInput.value) maxInput.setAttribute('min', minInput.value);
    // if (minInput.value === '') maxInput.setAttribute('min', 0);
    // if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetGrid extends HTMLElement {
  constructor() {
    super();
    const facetLink = this;
    facetLink.addEventListener('click', this.changeGrid.bind(this));
    this.uploadGrid();
  }

  uploadGrid() {
    const gridProducts = document.getElementById('product-grid');
    const gridIcons = this.querySelectorAll('.facet-grid-icon');
    const userChoice = localStorage.getItem('gridChoice');

    if (userChoice === 'alternate-grid') {
      gridIcons[0].classList.toggle('hidden');
      gridIcons[1].classList.toggle('hidden');
      gridProducts.classList.toggle('grid--4-col-desktop');
      gridProducts.classList.toggle('grid--2-col-desktop');
      gridProducts.classList.toggle('grid--2-col-tablet-down');
      gridProducts.classList.toggle('grid--1-col-tablet-down');
    }
  }

  changeGrid(event) {
    event.preventDefault();
    const gridIcons = this.querySelectorAll('.facet-grid-icon');
    const gridProducts = document.getElementById('product-grid');

    gridIcons[0].classList.toggle('hidden');
    gridIcons[1].classList.toggle('hidden');
    gridProducts.classList.toggle('grid--4-col-desktop');
    gridProducts.classList.toggle('grid--2-col-desktop');
    gridProducts.classList.toggle('grid--2-col-tablet-down');
    gridProducts.classList.toggle('grid--1-col-tablet-down');

    if (gridProducts.classList.contains('grid--4-col-desktop')) {
      localStorage.setItem('gridChoice', 'default-grid');
    } else {
      localStorage.setItem('gridChoice', 'alternate-grid');
    }

  }
}

customElements.define('facet-grid', FacetGrid);